export default __webpack_public_path__ + "static/media/HDTX Ringkasan Risalah Minutes Summary GMS 2026.68bc858c.pdf";